import { createSelector } from "reselect";

const getPurchases = (state) => state.entities.purchases || {};
const getPurchasesList = (state) => state.purchasesList || {};
const getProductId = (_, productId) => productId;

export const getProductPurchases = createSelector(
  getPurchases,
  getPurchasesList,
  getProductId,
  (purchases, purchasesList, productId) => {
    const productPurchaseIds = purchasesList[productId]?.ids || [];
    return productPurchaseIds.map(id => purchases[id]).filter(Boolean);
  }
);

export const getProductPurchasesLoading = createSelector(
  getPurchasesList,
  (purchasesList) => purchasesList.loading || false
);

export const getProductPurchasesError = createSelector(
  getPurchasesList,
  (purchasesList) => purchasesList.error || null
);

export const getProductPurchasesPagination = createSelector(
  getPurchasesList,
  getProductId,
  (purchasesList, productId) => purchasesList[productId]?.pagination || null
);

export const getUserPurchases = createSelector(
  getPurchases,
  getPurchasesList,
  (purchases, purchasesList) => {
    const ids = purchasesList.userPurchases?.ids || [];
    return ids.map(id => purchases[id]).filter(Boolean);
  }
);

export const getUserPurchasesLoading = createSelector(
  getPurchasesList,
  (purchasesList) => purchasesList.userLoading || false
);

export const getUserPurchasesPagination = createSelector(
  getPurchasesList,
  (purchasesList) => purchasesList.userPurchases?.pagination || null
);
